import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Modal = ({ isOpen, onClose }) => {
  const menuItems = [
    { title: 'Home', href: '/' },
    { title: 'Services', href: '/services' },
    { title: 'Portfolio', href: '/portfolio' },
    { title: 'Contact', href: '#contact' },
  ];

  const modalVariants = {
    initial: { 
      scale: 0,
      opacity: 0,
      borderRadius: '100%',
    },
    animate: { 
      scale: 1,
      opacity: 1,
      borderRadius: '0%',
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
    exit: { 
      scale: 0,
      opacity: 0,
      borderRadius: '100%',
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
  };

  const contentVariants = {
    initial: { opacity: 0, y: -20 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        delay: 0.3,
        duration: 0.3,
      },
    },
    exit: { opacity: 0, y: -20 },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-start justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div style={{ backgroundColor: '#f9f4ee91', backdropFilter: 'blur(15px)', WebkitBackdropFilter: 'blur(15px)' }}
            className="absolute inset-0"
            variants={modalVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
          <motion.div
            className="relative w-full h-full flex flex-col items-center justify-center text-white"
            variants={contentVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <button style={{ cursor: 'pointer' , padding:'0.8rem' , borderRadius:'50%'}}
              onClick={onClose}
              className="absolute bottom-[150px] bg-black  items-center text-white hover:text-gray-300 transition-colors"
              aria-label="Close menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <nav>
              <ul className="space-y-6">
                
                {menuItems.map((item, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 + index * 0.1 }}
                    className="text-center"
                  >
                    <a
                      href={item.href}
                      onClick={onClose}
                      className="text-4xl font-semibold text-black hover:underline transition-colors"
                    >
                      {item.title}
                      
                    </a>
                  </motion.li>
                ))}
              </ul>
            </nav>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;





